// extracted by mini-css-extract-plugin
export var badge = "tabs-module--badge--agsCO";
export var plus = "tabs-module--plus--muyDR";
export var root = "tabs-module--root--dfbDQ";
export var tab = "tabs-module--tab--0iexL";
export var tabActive = "tabs-module--tabActive---Mor-";
export var tabIcon = "tabs-module--tabIcon--6yjvc";